// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__2IP_b","pendingPaymentIcon":"CalendarEvent_pendingPaymentIcon__NZCta","gfeWrapper":"CalendarEvent_gfeWrapper__1mSCK"};